<mat-tab-group #tabs animationDuration="0ms" (selectedIndexChange)="selectedTabIndex = $event">
  <mat-tab>
    <ng-template mat-tab-label>
      <div
        class="d-flex align-items-center justify-content-center"
        [ngClass]="{
          hilite: modifyingCatalogs?.includes(catalog.Roles) && roleModified,
        }"
      >
        Role Details
      </div>
    </ng-template>
    <div
      class="p-2 roleModified"
      [ngClass]="{
        showRoleModified:
          roleModified && modifyingCatalogs?.includes(catalog.Roles),
      }"
    >
      <form [formGroup]="formGroup">
        <div class="container-fluid pt-2">
          <div class="row">
            <div class="col-4">
              <mat-form-field
                [ngClass]="{
                  hilite:
                    role && roleModified && roleCodeCtrl.value != role.code,
                }"
              >
                <mat-label>Abbreviated Role Name</mat-label>
                <input
                  aria-label="code"
                  matInput
                  #roleCode
                  id="roleCode"
                  [formControl]="roleCodeCtrl"
                  (change)="roleChanged($event)"
                  name="roleCode"
                />
                <mat-error *ngIf="roleCodeCtrl.invalid">
                  {{ getErrorMsg(roleCodeCtrl) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field
                [ngClass]="{
                  hilite:
                    role && roleModified && statusCtrl.value != role.status,
                }"
              >
                <mat-label>Status</mat-label>
                <mat-select
                  [formControl]="statusCtrl"
                  *ngIf="!deleted"
                  (selectionChange)="changeStatusRole($event.value)"
                  name="status"
                >
                  <mat-option
                    *ngFor="let status of statusList"
                    [value]="status.id"
                  >
                    {{ status.name }}
                  </mat-option>
                </mat-select>
                <mat-select
                  [formControl]="statusCtrl"
                  *ngIf="deleted"
                  name="status"
                >
                  <mat-option [value]="0"> Deleted </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-4 offset-1 toggles">
              <div class="toggle-wrapper">
                <label class="toggle-title">Performs RSSWA Work</label>

                <div class="toggle-container">
                  <span
                    class="toggle-label"
                    [class.inactive]="performingWorkCtrl.value"
                    >OFF</span
                  >
                  <mat-slide-toggle
                    [formControl]="performingWorkCtrl"
                    name="performingWork"
                    (change)="setFormDirty()"
                    [ngClass]="{
                      hilite:
                        role &&
                        roleModified &&
                        performingWorkCtrl.value !== role.performingWork,
                    }"
                  >
                  </mat-slide-toggle>
                  <span
                    class="toggle-label"
                    [class.inactive]="!performingWorkCtrl.value"
                    >ON</span
                  >
                </div>
              </div>
              <div class="toggle-wrapper">
                <label class="toggle-title">Training</label>

                <div class="toggle-container">
                  <span
                    class="toggle-label"
                    [class.inactive]="trainingRoleCtrl.value"
                    >OFF</span
                  >
                  <mat-slide-toggle
                    [formControl]="trainingRoleCtrl"
                    name="trainingRole"
                    (change)="setFormDirty()"
                    [ngClass]="{
                      hilite:
                        role &&
                        roleModified &&
                        trainingRoleCtrl.value !== role.trainingRole,
                    }"
                  >
                  </mat-slide-toggle>

                  <span
                    class="toggle-label"
                    [class.inactive]="!trainingRoleCtrl.value"
                    >ON</span
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12">
              <mat-form-field
                [ngClass]="{
                  hilite:
                    role && roleModified && roleNameCtrl.value != role.name,
                }"
              >
                <mat-label>Full Role Name</mat-label>
                <input
                  aria-label="name"
                  matInput
                  [formControl]="roleNameCtrl"
                  name="roleName"
                  (change)="roleNameChanged($event)"
                />
                <mat-error *ngIf="roleNameCtrl.invalid">
                  {{ getErrorMsg(roleNameCtrl) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-12">
              <div class="textarea-with-counter">
                <mat-form-field
                  [ngClass]="{
                    hilite:
                      role &&
                      roleModified &&
                      roleInformationCtrl.value != role.information,
                  }"
                >
                  <mat-label>APL Info</mat-label>
                  <textarea
                    aria-label="information"
                    matInput
                    style="overflow: hidden"
                    name="information"
                    [formControl]="roleInformationCtrl"
                    (keydown)="keydown($event)"
                    (change)="setFormDirty()"
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                  >
                  </textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-sm-12">
              <apl-category-autocomplete
                [placeholder]="'APL Category'"
                [disabled]="true"
                [aplCategoryID]="
                  role?.aplGroupRole?.aplGroup?.aplGroupMaster
                    ?.aplCategoryMaster?.aplCategory?.id
                "
                (aplCategoryIDChange)="aplCategoryIDChanged($event)"
                [hilite]="
                  role &&
                  roleModified &&
                  role.aplGroupRole?.aplGroup?.aplGroupMaster?.aplCategoryMaster
                    ?.aplCategory?.id !=
                    role.aplGroupRole?.aplGroup?.aplGroupMaster
                      ?.aplCategoryMaster?.aplCategory?.id
                "
              >
              </apl-category-autocomplete>
            </div>
            <div class="col-md-6 col-sm-12">
              <mat-form-field>
                <mat-label>APL Category Manager</mat-label>
                <input
                  aria-label="group"
                  matInput
                  type="text"
                  [value]="
                    getCategoryManagers(
                      role?.aplGroupRole?.aplGroup?.aplGroupMaster
                        ?.aplCategoryMaster?.aplCategory
                    ) ?? []
                  "
                  [disabled]="true"
                />
              </mat-form-field>
            </div>
            <div class="col-md-6 col-sm-12">
              <apl-group-autocomplete
                [placeholder]="'APL Group'"
                [disabled]="true"
                [aplGroupID]="role?.aplGroupRole?.aplGroup?.id"
                (aplGroupIDChange)="aplGroupIDChanged($event)"
                [hilite]="
                  role &&
                  roleModified &&
                  role.aplGroupRole?.aplGroup?.id !=
                    role.aplGroupRole?.aplGroup?.id
                "
              >
              </apl-group-autocomplete>
            </div>
            <div class="col-md-6 col-sm-12">
              <mat-form-field>
                <mat-label>APL Group Manager</mat-label>
                <input
                  aria-label="role"
                  matInput
                  type="text"
                  [value]="getGroupManagers(role?.aplGroupRole?.aplGroup) ?? []"
                  [disabled]="true"
                />
              </mat-form-field>
            </div>
            <div class="col-md-6 col-sm-12">
              <mat-form-field>
                <mat-label>Procedure Training Coordinator</mat-label>
                <input
                  aria-label="x"
                  matInput
                  type="text"
                  [value]="
                    getProcedureCenterCoordinators(
                      role?.aplGroupRole?.aplGroup
                    ) ?? []
                  "
                  [disabled]="true"
                />
              </mat-form-field>
            </div>
            <div class="col-12">
              <!-- Related Documents and Links -->
              <related-link-chips
                class="mb-1"
                label="Required WPC"
                [relatedLinks]="relatedLinks"
                [disabled]="!(adding || modifying) || (isOnlyPTC ?? true)"
                [formId]="role?.id"
                [hilite]="checkDiffWPCLinks()"
                (onEdited)="relatedLinksChanged($event)"
              ></related-link-chips>
            </div>
            <div class="col-12 delete-role-row">
              <button
                mat-flat-button
                color="warn"
                *ngIf="role && (modifying || canDeleteRole())"
                [disabled]="!canDeleteRole()"
                (click)="deleteRole()"
              >
                <mat-icon>delete</mat-icon> Delete Role
              </button>
              <p
                class="delete-role-message"
                *ngIf="
                  role &&
                  modifying &&
                  !canDeleteRole() &&
                  !isOnlyPTC
                "
              >
                You must set the role to inactive, have that inactive status
                approved, and delete all the role users to delete the role.
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <div
        class="d-flex align-items-center justify-content-center"
        [ngClass]="{
          hilite: modifyingCatalogs?.includes(catalog.Users) && roleModified,
        }"
      >
        Users
      </div>
    </ng-template>
    <div
      class="container-fluid mt-2 roleModified"
      [ngClass]="{
        showRoleModified:
          roleModified && modifyingCatalogs?.includes(catalog.Users),
      }"
    >
      <app-role-users
        #roleUsers
        [role]="role"
        [displayedRole]="displayedRole"
        [modifying]="modifying"
        [adding]="adding"
        [dragEnabled]="dragEnabled"
        [isOnlyPTC]="isOnlyPTC"
        [showRoleModified]="roleModified"
        (usersChange)="onRoleUsersChange($event)"
        (dirty)="setFormDirty()"
      ></app-role-users>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <div
        class="d-flex align-items-center justify-content-center"
        [ngClass]="{
          hilite:
            modifyingCatalogs?.includes(catalog.RolePrivileges) && roleModified,
        }"
      >
        Privileges
      </div>
    </ng-template>
    <div
      class="container-fluid mt-2 roleModified"
      [ngClass]="{
        showRoleModified:
          roleModified && modifyingCatalogs?.includes(catalog.RolePrivileges),
      }"
    >
      <div class="d-flex justify-content-center">
        <span class="red small"
          >Privileges can only be modified by System Administrators</span
        >
      </div>
      <role-privilege
        [role]="displayedRole"
        [showChanges]="roleModified"
        [modifying]="modifying || adding"
        (rolePrivilegesPendingChanged)="setRolePrivilegesPending($event)"
      ></role-privilege>
    </div>
  </mat-tab>
  <mat-tab *ngIf="displayedRole?.trainingRole">
    <ng-template mat-tab-label>
      <div
        class="d-flex align-items-center justify-content-center"
        [ngClass]="{
          hilite:
            modifyingCatalogs?.includes(catalog.Trainings) && roleModified,
        }"
      >
        {{ getMessage("ALSPC_RolesCatalog_Training").description }}
      </div>
    </ng-template>
    <div
      class="container-fluid mt-2 roleModified"
      [ngClass]="{
        showRoleModified:
          roleModified && modifyingCatalogs?.includes(catalog.Trainings),
      }"
    >
      <app-role-training
        #roleTraining
        [role]="role"
        [displayedRole]="displayedRole"
        [adding]="adding"
        [modifying]="modifying"
        [active]="selectedTabIndex === 3"
        [procedureTrainings]="procedureTrainings"
        [procedures]="procedures"
        (trainingsChange)="onRoleTrainingsChange($event)"
        (dirty)="setFormDirty()"
      ></app-role-training>
    </div>
  </mat-tab>
</mat-tab-group>

<div class="sidenav-content-buttons">
  <div class="row">
    <div class="col-6">
      <button
        *ngIf="modifying || adding"
        mat-stroked-button
        color="warn"
        (click)="discardChanges()"
        class="w-100px"
      >
        Cancel
      </button>
      <button
        *ngIf="(_service.canCancel | async) && !adding && !modifying"
        mat-flat-button
        color="warn"
        (click)="cancelPendingChanges()"
        class="w-100px"
      >
        Cancel
      </button>
    </div>
    <div class="col-6 d-flex justify-content-end align-items-center p-0 gap-2">
      <button
        mat-flat-button
        color="accent"
        *ngIf="(_service.canModify | async) && !modifying && !adding"
        (click)="modifyRole()"
        class="w-100px"
      >
        Modify
      </button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="isModifying || (tabs.selectedIndex == 2 && !isSA())"
        *ngIf="
          role?.id &&
          !modifying &&
          this.currentUser &&
          !role?.status &&
          !roleHasPendingChanges()
        "
        (click)="activateRole()"
        class="w-100px"
      >
        Activate
      </button>
      <button
        mat-flat-button
        color="primary"
        *ngIf="modifying || adding"
        [disabled]="!isFormDirty() || !formGroup.valid"
        (click)="saveRole()"
        class="w-100px"
      >
        Save
      </button>
      <button
        mat-flat-button
        color="primary"
        class="w-100px"
        *ngIf="_service.canApprove | async"
        (click)="approve()"
      >
        Approve
      </button>
      <button
        mat-flat-button
        color="warn"
        class="w-100px"
        *ngIf="_service.canApprove | async"
        (click)="openAddDisapprovalDialog()"
      >
        Disapprove
      </button>
    </div>
  </div>
</div>
